import * as React from 'react';
import { GuideStep, StepType } from '../guide';
type RowProps = {
  step: GuideStep;
  setEditing: Function;
};

const amountVisible = (type: StepType): boolean => {
  return type === StepType.bloom || type === StepType.pour;
};

export default function GuideStepRowSummary(props: RowProps) {
  return (
    <div className="flex-ns flex-wrap-s items-center">
      <div className="pr3">
        <img
          className="br-100 w3 h3 dib"
          src={`/images/steps/${props.step.type}.png`}
          alt="Coffee Dose"
        />
      </div>
      <div className="flex-auto pr3">
        <h4>{props.step.name}</h4>
        {props.step.description_text && (
          <p className="black-70">{props.step.description_text}</p>
        )}
      </div>
      {amountVisible(props.step.type) && (
        <div className="w-50 w-10-ns tc pr3 b">
          <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Amount</h4>
          {props.step.amount}
          {props.step.amount_unit}
        </div>
      )}
      <div className="w-50 w-10-ns tc pr3 b">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Duration</h4>
        {props.step.time_duration}s
      </div>
      <div className="w-10 tr pr3 b">
        <button
          type="button"
          className="mv4 black underline b db link bg-transparent bw0 pointer"
          onClick={() => props.setEditing(true)}
        >
          Edit
        </button>
      </div>
    </div>
  );
}
